import React, {useEffect, useState, memo} from "react";
import {
    extractPossibleLevel5,
    extractPossibleLevel6,
    extractPossibleLevel8,
    extractPossibleLevel9,
    extractPossibleLevel10,
    Level5FilterMapping,
    Level6BackwardMapping,
    Level6FilterMapping,
    Level8BackwardMapping,
    Level8FilterMapping,
    Level9FilterMapping,
    Level9BackwardMapping,
    Level9ForwardMapping,
    Level10ForwardMapping,
    Level10BackwardMapping
} from "../../../utils/level_mapping_helper";
import {
    Badge, TableCell, TableRow,
    Tooltip, TextField, IconButton,
    Typography, Box, Chip
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import SearchableDropdown from "./SearchableDropdown.comp";
import ChatIcon from '@material-ui/icons/Chat';
import HistoryIcon from '@material-ui/icons/History';
import {LM_TYPE} from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
    clickable_text: {
        borderBottom: "1px dotted #000",
        cursor: "pointer"
    },
    message_tf: {
        minWidth: '500px'
    },
    read_only_tf: {
        minWidth: '60px'
    },
    modified_row: {
        borderLeft: '5px solid orange',
    },
    deleted_row: {
        borderLeft: '5px solid red',
        backgroundColor: '#ffcccc'
    }
}))

const TooltipContent = (naming) => naming ? <Typography style={{color: "white"}}>{naming.full_name}<hr style={{backgroundColor: "white"}}/><span>{naming.definition}</span></Typography> : "";

const MemoLearningMessageRow = memo(LearningMessageRow);
export default MemoLearningMessageRow;
function LearningMessageRow(props) {

    const classes = useStyles();

    const {message_object: message, index, mappings, updateMessage, openComments, openLogs, is_deleted} = props;

    const [availableLevel5, setAvailableLevel5] = useState([]);
    const [availableLevel6, setAvailableLevel6] = useState([]);
    const [availableLevel8, setAvailableLevel8] = useState([]);
    const [availableLevel9, setAvailableLevel9] = useState([]);
    const [availableLevel10, setAvailableLevel10] = useState([]);

    const [selectedLevel5, setSelectedLevel5] = useState(message.v3dqc_no);
    const [selectedLevel6, setSelectedLevel6] = useState(message.v3dqco_no);
    const [selectedLevel8, setSelectedLevel8] = useState(message.v3unit_no);
    const [selectedLevel9, setSelectedLevel9] = useState(message.v3session_no);
    const [selectedLevel10, setSelectedLevel10] = useState(message.v3element_no);
    // const [selectedMB, setSelectedMB] = useState(message.mb_no);
    // const [selectedDQC, setSelectedDQC] = useState(message.dqc_no);
    // const [selectedDQ, setSelectedDQ] = useState(message.dq_no);
    const [selectedCat4, setSelectedCat4] = useState(message.v3element_ksab_dimensions);

    const [firstTime, setFirstTime] = useState(true);

    const isLevelNA = selectedLevel5 === "N/A" || selectedLevel6 === "N/A" || selectedLevel8 === "N/A" || selectedLevel9 === "N/A"
    const isModified = message.v3_element_sim === 100;

    const { v3dqcs_namings, v3dqcos_namings, v3units_namings, v3sessions_namings, v3elements_namings} = mappings;
    const level5_tooltip = v3dqcs_namings[selectedLevel5] && !isLevelNA ? TooltipContent(v3dqcs_namings[selectedLevel5]) : "";
    const level6_tooltip = v3dqcos_namings[selectedLevel6] && !isLevelNA ? TooltipContent(v3dqcos_namings[selectedLevel6]) : "";
    const level8_tooltip = v3units_namings[selectedLevel8] && !isLevelNA ? TooltipContent(v3units_namings[selectedLevel8]) : "";
    const level9_tooltip = v3sessions_namings[selectedLevel9] && !isLevelNA ? TooltipContent(v3sessions_namings[selectedLevel9]) : "";
    const level10_tooltip = v3elements_namings[selectedLevel10] && !isLevelNA ? TooltipContent(v3elements_namings[selectedLevel10]) : "";

    useEffect(() => {

        const possible_level5 = extractPossibleLevel5(mappings);
        const possible_level6 = extractPossibleLevel6(mappings);
        const possible_level8 = extractPossibleLevel8(mappings);
        const possible_level9 = extractPossibleLevel9(mappings);
        const possible_level10 = extractPossibleLevel10(mappings);

        setAvailableLevel5(possible_level5);
        if(!isLevelNA && possible_level5.includes(message.v3dqc_no)) {
            const {level6, level8, level9, level10} = Level5FilterMapping(mappings, message.v3dqc_no); //extract specific levels w.r.t level 5
            setAvailableLevel6(level6); //set specific possible level 6
            if(level6.includes(message.v3dqco_no)) {
                const {level8, level9, level10} = Level6FilterMapping(mappings, message.v3dqco_no); //extract specific levels w.r.t level 6
                setAvailableLevel8(level8); //set specific possible level 8
                if(level8.includes(message.v3unit_no)) {
                    const {level9, level10} = Level8FilterMapping(mappings, message.v3unit_no);  //extract specific levels w.r.t level 8
                    setAvailableLevel9(level9); //set specific possible level 9
                    if (level9.includes(message.v3session_no)) {
                        const { level10 } = Level9FilterMapping(mappings, message.v3session_no);
                        setAvailableLevel10(level10);
                    } else {
                        setAvailableLevel10(level10);
                    }
                } else {
                    setAvailableLevel9(level9);
                    setAvailableLevel10(level10);
                }
            } else {
                setAvailableLevel8(level8);
                setAvailableLevel9(level9);
                setAvailableLevel10(level10);
            }
        }
        else {
            setAvailableLevel6(possible_level6);
            setAvailableLevel8(possible_level8);
            setAvailableLevel9(possible_level9);
            setAvailableLevel10(possible_level10);
        }
    }, [])

    function onChangeToNA() {
        updateMessage(index, {
            v3dqc_no: "N/A",
            v3dqco_no: "N/A",
            v3unit_no: "N/A",
            v3session_no: "N/A",
            v3element_no: "N/A",
            // mb_no: "N/A",
            // dqc_no: "N/A",
            // dq_no: "N/A",
            v3element_ksab_dimensions: "N/A",
        });
        setSelectedLevel9("N/A");
        setSelectedLevel8("N/A");
        setSelectedLevel6("N/A");
        setSelectedLevel5("N/A");
        // setSelectedMB("N/A");
        // setSelectedDQC("N/A");
        // setSelectedDQ("N/A");
        setSelectedCat4("N/A");
        updateOptionsWithAll();
    }

    function updateOptionsWithAll() {
        setAvailableLevel5(extractPossibleLevel5(mappings));
        setAvailableLevel6(extractPossibleLevel6(mappings));
        setAvailableLevel8(extractPossibleLevel8(mappings));
        setAvailableLevel9(extractPossibleLevel9(mappings));
        setAvailableLevel10(extractPossibleLevel10(mappings));
    }

    function updateOptionsWithLevel5(level5) {
        if(level5 !== null && level5 !== "N/A") {
            const {level6, level8, level9} = Level5FilterMapping(mappings, level5);
            setAvailableLevel6(level6);
            setAvailableLevel8(level8);
            setAvailableLevel9(level9);
        }
    }

    function updateOptionsWithLevel6(level6) {
        if(level6 !== null && level6 !== "N/A") {
            const {level8, level9} = Level6FilterMapping(mappings, level6);
            setAvailableLevel8(level8);
            setAvailableLevel9(level9);
        }
    }

    function updateOptionsWithLevel8(level8) {
        if(level8 !== null && level8 !== "N/A") {
            const {level9} = Level8FilterMapping(mappings, level8);
            setAvailableLevel9(level9);
        }
    }

    function onChangeLevel5(level5) {
        if(level5 !== null) {
            if(level5 === "N/A") return onChangeToNA();
            //updating options
            updateOptionsWithLevel5(level5);
            updateMessage(index, {v3dqc_no: level5, v3_element_sim: 100})
        }
        else {
            updateOptionsWithAll();
        }
    }

    function onChangeLevel6(level6) {
        if(level6 !== null) {
            if(level6 === "N/A") return onChangeToNA();
            //updating options
            updateOptionsWithLevel6(level6)
            //updating previous selection
            const {level5 = null} = Level6BackwardMapping(mappings, level6);
            setSelectedLevel5(level5);
            updateMessage(index, {v3dqc_no: level5, v3dqco_no: level6, v3_element_sim: 100})
        }
        else {
            updateOptionsWithLevel5(selectedLevel5);
        }
    }

    function onChangeLevel8(level8) {
        if(level8 !== null) {
            if(level8 === "N/A") return onChangeToNA();
            //updating options
            updateOptionsWithLevel8(level8)
            //updating previous selection
            const {level5 = null, level6 = null} = Level8BackwardMapping(mappings, level8);
            setSelectedLevel6(level6);
            setSelectedLevel5(level5);
            updateMessage(index, {v3dqc_no: level5, v3dqco_no: level6, v3unit_no: level8, v3_element_sim: 100})
        }
        else {
            updateOptionsWithLevel6(selectedLevel6);
        }
    }

    function onChangeLevel9(level9) {
        if(level9 !== null) {
            if(level9 === "N/A") return onChangeToNA();
            //updating previous selection
            const result = Level9BackwardMapping(mappings, level9);
            const {level5 = null, level6 = null, level8 = null} = result;
            setSelectedLevel8(level8);
            setSelectedLevel6(level6);
            setSelectedLevel5(level5);
            //updating forward selection
            const {level10, level10_ksab_dimensions = ""} = Level9ForwardMapping(mappings, level9);

            // setSelectedMB(mb_no);
            // setSelectedDQC(dqc_no);
            // setSelectedDQ(dq_no);
            setSelectedCat4(level10_ksab_dimensions);
            //updating message
            updateMessage(index, {
                v3dqc_no: level5,
                v3dqco_no: level6,
                v3unit_no: level8,
                v3session_no: level9,
                v3element_no: level10,
                // mb_no: mb_no,
                // dqc_no: dqc_no,
                // dq_no: dq_no,
                v3element_ksab_dimensions: level10_ksab_dimensions,
                v3_element_sim: 100,
            });
        }
        else {
            updateOptionsWithLevel8(selectedLevel8);
        }
    }

    function onChangeLevel10(level10) {
        if (level10 !== null) {
            if (level10 === 'N/A') return onChangeToNA();

            const {
                v3session_no = '',
                v3unit_no = '',
                v3dqco_no = '',
                v3dqc_no = ''
            } = Level10BackwardMapping(mappings, level10);
            const { level10_ksab_dimensions } = Level10ForwardMapping(mappings, level10);

            setSelectedLevel10(level10);
            setSelectedLevel9(v3session_no);
            setSelectedLevel8(v3unit_no);
            setSelectedLevel6(v3dqco_no)
            setSelectedLevel5(v3dqc_no);
            setSelectedCat4(level10_ksab_dimensions);

            updateMessage(index, {
                v3element_no: level10,
                v3session_no: v3session_no,
                v3unit_no: v3unit_no,
                v3dqco_no: v3dqco_no,
                v3dqc_no: v3dqc_no,
                v3element_ksab_dimensions: level10_ksab_dimensions,
                v3_element_sim: 100
            });
        }
    }

    // function changeLevel9RelatedFields(level9) {
    //     const {mb_no = "", dqc_no = "", dq_no = "", category_4 = ""} = Level9ForwardMapping(mappings, level9);
    //     setSelectedMB(mb_no);
    //     setSelectedDQC(dqc_no);
    //     setSelectedDQ(dq_no);
    //     setSelectedCat4(category_4);
    // }

    return <TableRow className={is_deleted ? classes.deleted_row : isModified ? classes.modified_row : undefined}>
        <TableCell>
            {message.message_id}
        </TableCell>
        <TableCell className={classes.message_tf}>
            {
                <span>
                {
                    message.message.split('\n').map((text, text_idx) =>
                        <>
                            {text_idx !== 0 && <br/>}
                            <span>{text}</span>
                        </>)
                }
                </span>
            }
            {
                message.type === LM_TYPE.INSTRUMENT ?
                    <>
                        <br/>
                        <br/>
                        {
                            message.responses.map((resp) =>
                                <Chip
                                    style={{marginRight: 5, marginTop: 5}}
                                    size="small"
                                    label={resp}
                                    clickable={false}
                                />
                            )
                        }
                    </>
                    : null
            }
        </TableCell>
        <TableCell>
            <SearchableDropdown
                id='level5'
                selected={selectedLevel5}
                setSelected={setSelectedLevel5}
                defaultValue={message.v3dqc_no}
                options={["N/A", ...availableLevel5]}
                formatOption={(option) => option in v3dqcs_namings ? `${option} (${v3dqcs_namings[option].full_name})` : option}
                onChange={onChangeLevel5}
                tooltip={level5_tooltip}
                optionsTooltips={Object.fromEntries(["N/A", ...availableLevel5].map((o) => [o, TooltipContent(v3dqcs_namings[o])]))}
            />
        </TableCell>
        <TableCell>
            <SearchableDropdown
                id='level6'
                selected={selectedLevel6}
                setSelected={setSelectedLevel6}
                defaultValue={message.v3dqco_no}
                options={["N/A", ...availableLevel6]}
                formatOption={(option) => option in v3dqcos_namings ? `${option} (${v3dqcos_namings[option].full_name})` : option}
                onChange={onChangeLevel6}
                tooltip={level6_tooltip}
                optionsTooltips={Object.fromEntries(["N/A", ...availableLevel6].map((o) => [o, TooltipContent(v3dqcos_namings[o])]))}
            />
        </TableCell>
        <TableCell>
            <SearchableDropdown
                id='level8'
                selected={selectedLevel8}
                setSelected={setSelectedLevel8}
                defaultValue={message.v3unit_no}
                options={["N/A", ...availableLevel8]}
                formatOption={(option) => option in v3units_namings ? `${option} (${v3units_namings[option].full_name})` : option}
                onChange={onChangeLevel8}
                tooltip={level8_tooltip}
                optionsTooltips={Object.fromEntries(["N/A", ...availableLevel8].map((o) => [o, TooltipContent(v3units_namings[o])]))}
            />
        </TableCell>
        <TableCell>
            <SearchableDropdown
                id='level9'
                selected={selectedLevel9}
                setSelected={setSelectedLevel9}
                defaultValue={message.v3session_no}
                options={["N/A", ...availableLevel9]}
                formatOption={(option) => option in v3sessions_namings ? `${option} (${v3sessions_namings[option].full_name})` : option}
                onChange={onChangeLevel9}
                tooltip={level9_tooltip}
                optionsTooltips={Object.fromEntries(["N/A", ...availableLevel9].map((o) => [o, TooltipContent(v3sessions_namings[o])]))}
            />
        </TableCell>
        <TableCell>
            <SearchableDropdown
                id='level10'
                selected={selectedLevel10}
                setSelected={setSelectedLevel10}
                defaultValue={message.v3element_no}
                options={["N/A", ...availableLevel10]}
                formatOption={(option) => option in v3elements_namings ? `${option} (${v3elements_namings[option].full_name})` : option}
                onChange={onChangeLevel10}
                tooltip={level10_tooltip}
                optionsTooltips={Object.fromEntries(["N/A", ...availableLevel10].map((o) => [o, TooltipContent(v3elements_namings[o])]))}
            />
        </TableCell>
        {/*<TableCell>*/}
        {/*    <TextField className={classes.read_only_tf} id='mb_no' value={selectedMB} variant="outlined" size="small" InputProps={{readOnly: true}}/>*/}
        {/*</TableCell>*/}
        {/*<TableCell>*/}
        {/*    <TextField className={classes.read_only_tf} id='dqc_no' value={selectedDQC} variant="outlined" size="small" InputProps={{readOnly: true}}/>*/}
        {/*</TableCell>*/}
        {/*<TableCell>*/}
        {/*    <TextField className={classes.read_only_tf} id='dq_no' value={selectedDQ} variant="outlined" size="small" InputProps={{readOnly: true}}/>*/}
        {/*</TableCell>*/}
        <TableCell>
            <TextField className={classes.read_only_tf} id='category_4' value={selectedCat4} variant="outlined" size="small" InputProps={{readOnly: true}}/>
        </TableCell>
        <TableCell>
            <Box display={'flex'} flexDirection={'row'}>
                <Tooltip title={'Comments'}>
                    <IconButton onClick={() => openComments(index)}>
                        <Badge color="primary" badgeContent={message.comments.length}>
                            <ChatIcon color={"secondary"}/>
                        </Badge>
                    </IconButton>
                </Tooltip>
                <Tooltip title={'History'}>
                    <IconButton onClick={() => openLogs(index)}>
                        <HistoryIcon color={"secondary"}/>
                    </IconButton>
                </Tooltip>
            </Box>
        </TableCell>
    </TableRow>
}